import React from 'react'
import { Header, Footer, ContentHome } from './components'

import '../../styles/pages/home.css'

const Home = () => {
	return (
		<React.Fragment>
			<Header />
			<ContentHome />
			<Footer />
		</React.Fragment>
	)
}

export default Home
